import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, Server, Bot } from 'lucide-react';
import PageHeader from './ui/PageHeader';
import apiService from '../services/apiService';

const StatusRow = ({ ok, label, detail }) => (
  <div className="flex items-start justify-between gap-4 border-b border-white/10 py-3 last:border-0">
    <div className="flex items-center gap-2">
      {ok ? (
        <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-400" />
      ) : (
        <XCircle className="h-5 w-5 shrink-0 text-amber-400" />
      )}
      <span className="text-sm font-medium text-slate-200">{label}</span>
    </div>
    <span className="text-right text-sm text-slate-400">{detail}</span>
  </div>
);

const Integrations = () => {
  const [health, setHealth] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiService
      .fetchHealth()
      .then(setHealth)
      .catch((e) => setError(e.message));
  }, []);

  return (
    <div className="page-container">
      <PageHeader
        title="Entegrasyon durumu"
        description="Sosyal medya kampanya asistanı ve bilgi bankası bağlantılarının durumu."
      />

      {error && (
        <div className="mb-6 rounded-lg border border-rose-400/30 bg-rose-500/10 px-4 py-3 text-sm text-rose-200">
          {error}
        </div>
      )}

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="card">
          <div className="mb-4 flex items-center gap-2">
            <Server className="h-5 w-5 text-accent-300" />
            <h3 className="font-semibold text-white">Bu sunucu</h3>
          </div>
          {health ? (
            <>
              <StatusRow
                ok={health.storageDriver === 'postgres'}
                label="Veritabanı"
                detail={health.storageDriver || '—'}
              />
              <StatusRow
                ok={health.databaseConfigured}
                label="PostgreSQL bağlantısı"
                detail={health.databaseConfigured ? 'Yapılandırıldı' : 'Yok / JSON modu'}
              />
              <StatusRow
                ok={health.toolApiKeyConfigured}
                label="Araç API anahtarı"
                detail={health.toolApiKeyConfigured ? 'Aktif' : 'Kapalı (geliştirme)'}
              />
              <StatusRow
                ok={Boolean(health.n8nIngestKeyConfigured)}
                label="Özet aktarım anahtarı"
                detail={health.n8nIngestKeyConfigured ? 'Yapılandırıldı' : 'Eksik'}
              />
            </>
          ) : (
            <p className="text-sm text-slate-500">Yükleniyor…</p>
          )}
        </div>

        <div className="card">
          <div className="mb-4 flex items-center gap-2">
            <Bot className="h-5 w-5 text-accent-300" />
            <h3 className="font-semibold text-white">Sosyal Kampanya</h3>
          </div>
          {health ? (
            <>
              <StatusRow
                ok={health.metaConfigured}
                label="Meta Page Token"
                detail={health.metaConfigured ? 'Yapılandırıldı' : 'Harici otomasyon kullanılıyor'}
              />
              <StatusRow
                ok={health.campaignAiConfigured}
                label="Kampanya AI"
                detail={health.campaignAiConfigured ? 'Yapılandırıldı' : 'Kural tabanlı yedek'}
              />
              <StatusRow
                ok={health.pineconeConfigured}
                label="Bilgi bankası (RAG)"
                detail={health.pineconeConfigured ? 'Bağlı' : 'API anahtarı eksik'}
              />
              <StatusRow
                ok={(health.totalCampaignDocuments ?? 0) >= 0}
                label="Bilgi bankası dokümanları"
                detail={String(health.totalCampaignDocuments ?? 0)}
              />
              <StatusRow
                ok={(health.totalCampaigns ?? 0) > 0}
                label="Aktif kampanyalar"
                detail={String(health.totalCampaigns ?? 0)}
              />
            </>
          ) : (
            <p className="text-sm text-slate-500">Yükleniyor…</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Integrations;
